import { render, staticRenderFns } from "./CandidatesModalAdd.vue?vue&type=template&id=88ccd4b0&lang=pug"
import script from "./CandidatesModalAdd.vue?vue&type=script&lang=js"
export * from "./CandidatesModalAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports